export default "__VITE_ASSET__BGUA2oHt__"